import { observable, action, runInAction } from 'mobx';
import { isEmpty } from 'lodash';

import Service from '@service/index';

const moInfo = observable({
  industryList: <any[]>[],
  cityList: <any[]>[],
  cityCategoryList: <any[]>[],
  scaleList: <any[]>[],
  natureList: <any[]>[],
});

// 获取行业，城市，企业规模，企业性质
const getInfo = action(async (callback?: () => any) => {
  const cityArr: any[] = [];
  const res: any = await Service.info();
  if (isEmpty(res)) return;

  res.city?.map((item: any) => {
    if (!item.is_area_type && !item.is_city_type) cityArr.push(item);
  });

  runInAction(() => {
    moInfo.industryList = res.industry;
    moInfo.cityList = cityArr;
    moInfo.cityCategoryList = res.city_category;
    moInfo.scaleList = res.scale;
    moInfo.natureList = res.nature;

    if (callback) callback();
  });
});

export default moInfo;
export { getInfo };
